import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import requestReducer from "../slices/requestSlice";
import userReducer from "../slices/userSlice";
import routingReducer from "./routingReducer";

let reducers = combineReducers({
    request: requestReducer,
    user: userReducer,
    routing: routingReducer,
})

export default persistReducer(
    {
        key: "root",
        storage,
    }, 
    reducers
);